export enum HomeItemRoute {
  info = 'info',
  maplist = 'maplist',
  match = 'match',
  chat = 'chat',
  profile = 'profile',
}
